import React, { useEffect } from "react";
import styles from "../faq/faq.module.css";
import { useDispatch, useSelector } from "react-redux";
import { getTermsAndCondition } from "../../../redux/productsSlice";


const TermsCondition = () => {

    const dispatch = useDispatch();
    const { termsAndConditionData } = useSelector((state) => state.products);

    useEffect(() => {
        dispatch(getTermsAndCondition())
    }, [dispatch]);

    return (
        <div className={styles.container}>
            <h2>Terms & Conditions</h2>
            {/* FAQ Content */}
            <div className={styles.contentForTermsCondition}>
                <div className={styles.termsAndCondition} dangerouslySetInnerHTML={{ __html: termsAndConditionData?.termsAndCondition }}>
                </div>
            </div>

            <div className={styles.mobile_contant}>
                <div className={styles.termsAndCondition} dangerouslySetInnerHTML={{ __html: termsAndConditionData?.termsAndCondition }}>
                </div>
            </div>
        </div>
    );
};

export default TermsCondition;
